import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeepAliveRouterView = _resolveComponent("KeepAliveRouterView")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: "xag-flex-vertical",
    style: _normalizeStyle(_ctx.getAppContainerStyle)
  }, [
    (!_ctx.loading && !_ctx.userInfoLoading)
      ? (_openBlock(), _createBlock(_component_KeepAliveRouterView, { key: 0 }))
      : _createCommentVNode("", true)
  ], 4))
}